export default "__VITE_ASSET__Rz6jRaAw__"